import { render, staticRenderFns } from "./MobileOfferDefault.vue?vue&type=template&id=5d8667f4"
import script from "./MobileOfferDefault.vue?vue&type=script&lang=js"
export * from "./MobileOfferDefault.vue?vue&type=script&lang=js"
import style0 from "./MobileOfferDefault.vue?vue&type=style&index=0&id=5d8667f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports